import React from "react";
import { useState, useEffect, useMemo } from "react";
import { SamataRow } from "./SamataRow.jsx";
import { businessData } from "../api/businessData.js";

export function SamataView({ kainininkai, takeoffData }) {
          const [samatos, setSamatos] = useState([]);
          const [samatosLoaded, setSamatosLoaded] = useState(false);
          const [activeSId, setActiveSId] = useState(null);
          const [showNew, setShowNew] = useState(false);
          const [newName, setNewName] = useState('');
          const [priceMode, setPriceMode] = useState('client'); // 'client' or 'personal'

          useEffect(() => {
            let cancelled = false;
            businessData.getEstimates()
              .then(data => { if (!cancelled) setSamatos(data || []); })
              .catch(e => console.error('Failed to load samatos', e))
              .finally(() => { if (!cancelled) setSamatosLoaded(true); });
            return () => { cancelled = true; };
          }, []);

          useEffect(() => {
            if (!samatosLoaded) return;
            businessData.putEstimates(samatos).catch(e => console.error('Failed to save samatos', e));
          }, [samatos, samatosLoaded]);

          const activeS = samatos.find(s => s.id === activeSId) || samatos[0] || null;
          // Sinchronizuoti activeSId jei jis dar nenustatytas o sąmatos jau yra
          useEffect(() => {
            if (activeSId === null && samatos.length > 0) {
              setActiveSId(samatos[0].id);
            }
          }, [samatos, activeSId]);

          function addSamata() {
            if (!newName.trim()) return;
            const ns = { id: Date.now(), name: newName.trim(), items: [] };
            setSamatos(prev => [...prev, ns]);
            setActiveSId(ns.id);
            setNewName(''); setShowNew(false);
          }
          function delSamata(id) {
            if (!window.confirm('Ištrinti sąmatą?')) return;
            setSamatos(prev => prev.filter(s => s.id !== id));
            if (activeSId === id) setActiveSId(null);
          }

          // Collect all items from takeoff summary (grouped)
          const takeoffItems = useMemo(() => {
            if (!takeoffData) return [];
            return takeoffData;
          }, [takeoffData]);

          function importFromTakeoff() {
            if (!activeS) return;
            if (!takeoffItems || takeoffItems.length === 0) {
              alert('Takeoff suvestinėje nėra pozicijų. Pirmiausia pridėkite žymėjimų su priskirtomis pozicijomis Takeoff lape.');
              return;
            }
            // Surinkti visas kainininko pozicijas į flat sąrašą
            const kainFlat = [];
            (kainininkai || []).forEach(kain => {
              (kain.groups || []).forEach(g => {
                (g.items || []).forEach(it => kainFlat.push({ ...it, groupName: g.name, groupId: g.id, kainId: kain.id }));
              });
            });
            let matched = 0, unmatched = 0;
            const newItems = takeoffItems.map(it => {
              const found = kainFlat.find(k => (it.itemId && k.id && String(k.id) === String(it.itemId)) || (k.name && k.name.trim().toLowerCase() === (it.name||'').trim().toLowerCase()));
              if (found) matched++; else unmatched++;
              return {
                id: Date.now() + Math.random(),
                name: it.name,
                gamintojas: found ? (found.gamintojas || '') : '',
                unit: it.unit,
                qty: it.qty || 0,
                kainId: found ? found.kainId : null,
                clientPrice: found ? (parseFloat(found.priceInc) || parseFloat(found.priceEx) || 0) : 0,
                personalPrice: found ? (parseFloat(found.personalPrice) || 0) : 0,
                markup: 0,  // legacy, unused
                discount: 0,
                groupName: it.groupName || (found ? found.groupName : '')
              };
            });
            const targetId = activeSId !== null ? activeSId : (activeS ? activeS.id : null);
            if (!targetId) return;
            setSamatos(prev => prev.map(s => s.id === targetId ? {...s, items: newItems} : s));
            const msg = 'Importuota ' + newItems.length + ' pozicijų.' + (matched > 0 ? ' Rastos kainos: ' + matched + '.' : '') + (unmatched > 0 ? ' Be kainos: ' + unmatched + ' (kaininkoje nerasta).' : '');
            alert(msg);
          }

          function setItems(val) {
            setSamatos(prev => prev.map(s => {
              if (s.id !== activeSId) return s;
              const cur = s.items || [];
              const v = typeof val === 'function' ? val(cur) : val;
              return {...s, items: v};
            }));
          }

          const items = activeS ? (activeS.items || []) : [];

          // Backfill: senos pozicijos (importuotos prieš "Gamintojas" stulpelio pridėjimą)
          // turi kainId, bet neturi gamintojas reikšmės — papildome ją iš kainininko.
          useEffect(() => {
            if (!activeS || !items.length) return;
            const kainFlat = [];
            (kainininkai || []).forEach(kain => {
              (kain.groups || []).forEach(g => {
                (g.items || []).forEach(it => kainFlat.push({ ...it, kainId: kain.id }));
              });
            });
            if (!kainFlat.length) return;
            let changed = false;
            const patched = items.map(it => {
              if (it.gamintojas) return it;
              const found = kainFlat.find(k => (it.kainId && k.id && String(k.id) === String(it.kainId) && k.name && it.name && k.name.trim().toLowerCase() === it.name.trim().toLowerCase()) || (k.name && it.name && k.name.trim().toLowerCase() === it.name.trim().toLowerCase()));
              if (found && found.gamintojas) { changed = true; return { ...it, gamintojas: found.gamintojas }; }
              return it;
            });
            if (changed) setItems(patched);
          }, [activeSId, kainininkai]);

          const totalClient = items.reduce((a,it) => {
            const p = parseFloat(it.clientPrice)||0;
            const disc = parseFloat(it.discount)||0;
            return a + p * (1 - disc/100) * (parseFloat(it.qty)||0);
          }, 0);
          const totalPersonal = items.reduce((a,it) => {
            const p = parseFloat(it.personalPrice)||0;
            const disc = parseFloat(it.discount)||0;
            return a + p * (1 - disc/100) * (parseFloat(it.qty)||0);
          }, 0);
          const totalShown = priceMode === 'client' ? totalClient : totalPersonal;

          if (!samatosLoaded) {
            return <div style={{padding:24,color:'#383853',fontSize:13}}>Kraunama...</div>;
          }

          return (
            <div style={{display:'flex',height:'calc(100vh - 120px)',gap:0,background:'#f5f6fa'}}>
              {/* Kairė: sąmatų sąrašas */}
              <div style={{width:220,background:'#fff',borderRight:'1px solid #e5e7eb',display:'flex',flexDirection:'column',flexShrink:0}}>
                <div style={{padding:'12px 12px 8px',borderBottom:'1px solid #f0f0f0',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                  <span style={{fontSize:12,fontWeight:800,color:'#1c1c1c'}}>📊 SĄMATOS</span>
                  <button onClick={() => setShowNew(v=>!v)}
                    style={{background:'#383853',color:'#fff',border:'none',borderRadius:5,padding:'2px 8px',fontSize:11,fontWeight:700,cursor:'pointer'}}>+</button>
                </div>
                {showNew && (
                  <div style={{padding:'8px 10px',borderBottom:'1px solid #f0f0f0',background:'#f0f0f2'}}>
                    <input autoFocus value={newName} onChange={e=>setNewName(e.target.value)}
                      onKeyDown={e=>{if(e.key==='Enter')addSamata();if(e.key==='Escape'){setShowNew(false);setNewName('');}}}
                      placeholder="Sąmatos pavadinimas..."
                      style={{width:'100%',border:'1px solid #e5e7eb',borderRadius:5,padding:'5px 7px',fontSize:12,boxSizing:'border-box',marginBottom:5}}/>
                    <div style={{display:'flex',gap:5}}>
                      <button onClick={addSamata} style={{flex:1,background:'#383853',color:'#fff',border:'none',borderRadius:5,padding:'4px',fontSize:11,fontWeight:700,cursor:'pointer'}}>Sukurti</button>
                      <button onClick={()=>{setShowNew(false);setNewName('');}} style={{background:'#f3f4f6',border:'none',borderRadius:5,padding:'4px 8px',fontSize:11,cursor:'pointer'}}>✕</button>
                    </div>
                  </div>
                )}
                <div style={{flex:1,overflowY:'auto',padding:'4px 0'}}>
                  {samatos.length === 0 && <div style={{padding:'20px 12px',fontSize:11,color:'#9ca3af',textAlign:'center'}}>Nėra sąmatų.<br/>Sukurkite pirmą.</div>}
                  {samatos.map(s => (
                    <div key={s.id}
                      style={{display:'flex',alignItems:'center',gap:4,padding:'7px 10px',cursor:'pointer',borderRadius:5,margin:'1px 4px',
                        background:activeS&&activeS.id===s.id?'#f0f0f2':'transparent',
                        borderLeft:'3px solid '+(activeS&&activeS.id===s.id?'#383853':'transparent')}}
                      onClick={()=>setActiveSId(s.id)}>
                      <span style={{flex:1,fontSize:12,fontWeight:600,color:'#1c1c1c',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{s.name}</span>
                      <span style={{fontSize:10,color:'#9ca3af',flexShrink:0}}>{(s.items||[]).length} poz.</span>
                      <button onClick={e=>{e.stopPropagation();delSamata(s.id);}}
                        style={{background:'none',border:'none',color:'#d1d5db',cursor:'pointer',fontSize:14,padding:'0 2px',flexShrink:0}}>×</button>
                    </div>
                  ))}
                </div>
              </div>

              {/* Dešinė: sąmatos turinys */}
              <div style={{flex:1,overflowY:'auto',padding:'12px'}}>
                {!activeS ? (
                  <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%',flexDirection:'column',gap:12,color:'#9ca3af'}}>
                    <div style={{fontSize:40}}>📊</div>
                    <div style={{fontSize:14,fontWeight:600}}>Pasirinkite arba sukurkite sąmatą</div>
                  </div>
                ) : (
                  <div>
                    {/* Sąmatos valdymo juosta */}
                    <div style={{background:'#fff',borderRadius:10,padding:'12px 16px',marginBottom:12,display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',boxShadow:'0 1px 4px rgba(0,0,0,0.06)'}}>
                      <span style={{fontSize:15,fontWeight:800,color:'#1c1c1c',flex:1}}>{activeS.name}</span>
                      {/* Kainos pasirinkimas */}
                      <div style={{display:'flex',gap:0,background:'#f3f4f6',borderRadius:7,overflow:'hidden',border:'1px solid #e5e7eb'}}>
                        <button onClick={()=>setPriceMode('client')}
                          style={{padding:'5px 12px',fontSize:11,fontWeight:700,background:priceMode==='client'?'#383853':'transparent',color:priceMode==='client'?'#fff':'#6b7280',border:'none',cursor:'pointer'}}>
                          Kliento kainos
                        </button>
                        <button onClick={()=>setPriceMode('personal')}
                          style={{padding:'5px 12px',fontSize:11,fontWeight:700,background:priceMode==='personal'?'#15803d':'transparent',color:priceMode==='personal'?'#fff':'#6b7280',border:'none',cursor:'pointer'}}>
                          Asmeninės kainos
                        </button>
                      </div>
                      <button onClick={importFromTakeoff}
                        style={{background:'#735DFF',color:'#fff',border:'none',borderRadius:6,padding:'6px 14px',fontSize:12,fontWeight:700,cursor:'pointer'}}>
                        ↓ Importuoti iš Takeoff
                      </button>
                      <button onClick={()=>setItems(prev=>[...prev,{id:Date.now(),name:'',gamintojas:'',unit:'vnt.',qty:0,clientPrice:0,personalPrice:0,discount:0,groupName:'',kainId:null}])}
                        style={{background:'#383853',color:'#fff',border:'none',borderRadius:6,padding:'6px 14px',fontSize:12,fontWeight:700,cursor:'pointer'}}>
                        + Pozicija
                      </button>
                    </div>

                    {/* Sąmatos lentelė — grupuota pagal kainininko grupes */}
                    <div style={{background:'#fff',borderRadius:10,overflow:'hidden',boxShadow:'0 1px 4px rgba(0,0,0,0.06)'}}>
                      {(() => {
                        const grouped = [];
                        const seen = {};
                        items.forEach(it => {
                          const g = it.groupName || '(Be grupės)';
                          if (!seen[g]) { seen[g] = []; grouped.push({ group: g, rows: seen[g] }); }
                          seen[g].push(it);
                        });
                        const handleChange = (it) => (field, val) => {
                          setItems(prev => prev.map(x => {
                            if (x.id !== it.id) return x;
                            return {...x, [field]: val};
                          }));
                        };
                        const COLS = 10; // # | Gamintojas | Pavadinimas | Vnt. | Kiekis | Kaina | Nuolaida% | Kaina su nuolaida | Suma | actions
                        return (
                          <table style={{width:'100%',fontSize:11,borderCollapse:'collapse'}}>
                            <thead>
                              <tr style={{background:'#383853',color:'#fff'}}>
                                <th style={{padding:'8px',textAlign:'left',fontWeight:700,width:28}}>#</th>
                                <th style={{padding:'8px',textAlign:'left',fontWeight:700,width:110}}>Gamintojas</th>
                                <th style={{padding:'8px',textAlign:'left',fontWeight:700}}>Pozicija</th>
                                <th style={{padding:'8px 4px',textAlign:'center',fontWeight:700,width:50}}>Vnt.</th>
                                <th style={{padding:'8px',textAlign:'right',fontWeight:700,width:70}}>Kiekis</th>
                                <th style={{padding:'8px',textAlign:'right',fontWeight:700,color:priceMode==='client'?'#fde68a':'#bbf7d0',width:90}}>
                                  {priceMode==='client'?'Kliento kaina':'Asmeninė kaina'}
                                </th>
                                <th style={{padding:'8px',textAlign:'right',fontWeight:700,width:80}}>Nuolaida %</th>
                                <th style={{padding:'8px',textAlign:'right',fontWeight:700,width:110,color:'#bbf7d0'}}>Kaina su nuolaida</th>
                                <th style={{padding:'8px',textAlign:'right',fontWeight:700,color:'#fde68a',width:90}}>Suma</th>
                                <th style={{padding:'8px 4px',textAlign:'center',fontWeight:700,width:50}}></th>
                              </tr>
                            </thead>
                            <tbody>
                              {items.length === 0 && (
                                <tr><td colSpan={COLS} style={{padding:'30px',textAlign:'center',color:'#9ca3af'}}>Sąmata tuščia. Pridėkite pozicijų arba importuokite iš Takeoff.</td></tr>
                              )}
                              {grouped.map(({ group, rows }) => {
                                const [gDisc, setGDisc] = React.useState('');
                                const gTotal = rows.reduce((a, it) => {
                                  const p = priceMode==='client' ? (parseFloat(it.clientPrice)||0) : (parseFloat(it.personalPrice)||0);
                                  const d = parseFloat(it.discount)||0;
                                  return a + p * (1 - d/100) * (parseFloat(it.qty)||0);
                                }, 0);
                                const applyGroupDiscount = () => {
                                  const d = parseFloat(gDisc);
                                  if (isNaN(d)) return;
                                  setItems(prev => prev.map(x => rows.find(r=>r.id===x.id) ? {...x, discount: d} : x));
                                  setGDisc('');
                                };
                                return [
                                  <tr key={'grp_'+group} style={{background:'#e8eaed',borderTop:'2px solid #383853'}}>
                                    <td colSpan="6" style={{padding:'6px 10px',fontWeight:800,fontSize:11,color:'#374151',letterSpacing:0.2}}>
                                      📁 {group} <span style={{fontWeight:400,color:'#6b7280',marginLeft:6}}>{rows.length} poz.</span>
                                    </td>
                                    <td colSpan="2" style={{padding:'4px 6px'}}>
                                      <div style={{display:'flex',gap:4,alignItems:'center',justifyContent:'flex-end'}}>
                                        <input type="number" min="0" max="100" step="0.1"
                                          value={gDisc} onChange={e=>setGDisc(e.target.value)}
                                          onKeyDown={e=>e.key==='Enter'&&applyGroupDiscount()}
                                          placeholder="nuol. %"
                                          style={{width:70,border:'1px solid #c0c4cc',borderRadius:4,padding:'2px 5px',fontSize:10,textAlign:'right',boxSizing:'border-box'}}/>
                                        <button onClick={applyGroupDiscount}
                                          style={{background:'#383853',color:'#fff',border:'none',borderRadius:4,padding:'2px 7px',fontSize:10,fontWeight:700,cursor:'pointer',whiteSpace:'nowrap'}}>
                                          Taikyti
                                        </button>
                                      </div>
                                    </td>
                                    <td style={{padding:'6px 10px',textAlign:'right',fontWeight:800,fontSize:11,color:'#374151',whiteSpace:'nowrap'}}>
                                      {gTotal.toFixed(2)} €
                                    </td>
                                    <td></td>
                                  </tr>,
                                  ...rows.map((it, idx) => (
                                    <SamataRow key={it.id} it={it} idx={idx} priceMode={priceMode} kainininkai={kainininkai}
                                      onChange={handleChange(it)}
                                      onDel={()=>setItems(prev=>prev.filter(x=>x.id!==it.id))}/>
                                  ))
                                ];
                              })}
                            </tbody>
                            <tfoot>
                              <tr style={{background:'#f0f0f2',borderTop:'2px solid #383853'}}>
                                <td colSpan="8" style={{padding:'8px',fontWeight:700,textAlign:'right',color:'#1c1c1c'}}>IŠ VISO:</td>
                                <td style={{padding:'8px',textAlign:'right',fontWeight:800,fontSize:14,color:'#383853'}}>
                                  {totalShown.toFixed(2)} €
                                </td>
                                <td></td>
                              </tr>
                              <tr style={{background:'#f0f0f2'}}>
                                <td colSpan="8" style={{padding:'4px 8px',textAlign:'right',fontSize:10,color:'#9ca3af'}}>PVM 21%:</td>
                                <td style={{padding:'4px 8px',textAlign:'right',fontSize:11,color:'#9ca3af'}}>
                                  {(totalShown * 0.21).toFixed(2)} €
                                </td>
                                <td></td>
                              </tr>
                              <tr style={{background:'#383853'}}>
                                <td colSpan="8" style={{padding:'8px',fontWeight:700,textAlign:'right',color:'#fff'}}>IŠ VISO SU PVM:</td>
                                <td style={{padding:'8px',textAlign:'right',fontWeight:800,fontSize:14,color:'#fde68a'}}>
                                  {(totalShown * 1.21).toFixed(2)} €
                                </td>
                                <td></td>
                              </tr>
                            </tfoot>
                          </table>
                        );
                      })()}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        }
